/* The asterisk follows page travel; the wordmark and header never move. Pointing at the logo (mouse) or pressing it
   turns the asterisk once, as every star on the site (laserlab-site.js); a turn always finishes and never restarts
   halfway. Nothing moves when the visitor asks for less motion. */
if (!customElements.get('laserlab-scroll-logo')) {
  customElements.define('laserlab-scroll-logo', class extends HTMLElement {
    connectedCallback() {
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.updateRotation = () => {
        this.frame = null;
        const angle = this.motionPreference.matches ? 0 : Math.max(0, window.scrollY) * 0.12;
        this.style.setProperty('--ll-logo-angle', `${angle}deg`);
      };
      this.queueRotation = () => {
        if (this.frame == null) this.frame = requestAnimationFrame(this.updateRotation);
      };
      this.syncMotion = () => {
        window.removeEventListener('scroll', this.queueRotation);
        if (!this.motionPreference.matches) {
          window.addEventListener('scroll', this.queueRotation, { passive: true });
        }
        this.queueRotation();
      };
      this.motionPreference.addEventListener('change', this.syncMotion);
      window.addEventListener('pageshow', this.queueRotation);
      this.spin = () => {
        if (this.motionPreference.matches || this.classList.contains('is-spinning')) return;
        this.classList.add('is-spinning');
      };
      this.hoverSpin = event => { if (event.pointerType === 'mouse') this.spin(); };
      this.endSpin = () => this.classList.remove('is-spinning');
      this.addEventListener('pointerdown', this.spin);
      this.addEventListener('pointerenter', this.hoverSpin);
      this.addEventListener('animationend', this.endSpin);
      this.syncMotion();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.queueRotation);
      window.removeEventListener('pageshow', this.queueRotation);
      this.motionPreference.removeEventListener('change', this.syncMotion);
      this.removeEventListener('pointerdown', this.spin);
      this.removeEventListener('pointerenter', this.hoverSpin);
      this.removeEventListener('animationend', this.endSpin);
      cancelAnimationFrame(this.frame);
      this.frame = null;
    }
  });
}
